import React from 'react';
import { createRoot } from 'react-dom/client';
import { engine } from './core/audio/AudioEngine';
import { useAppStore } from './state/store';
import { sampleBank } from './core/samples/SampleBank';
import { normalizeProject } from './core/persistence/projectIO';
import { applyTheme, getStoredTheme } from './core/theme';
import App from './App';
import './styles.css';

// Apply the stored theme before first paint (avoids a flash of the wrong one).
applyTheme(getStoredTheme());

// Debug/test handle (used by scripts/smoke.mjs and the console).
window.__zangle = { engine, store: useAppStore, sampleBank, normalizeProject };

declare global {
  interface Window {
    __zangle?: {
      engine: typeof engine;
      store: typeof useAppStore;
      sampleBank: typeof sampleBank;
      normalizeProject: typeof normalizeProject;
    };
  }
}

// PWA: register the offline shell in production builds only.
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      /* offline shell is optional */
    });
  });
}

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);